import React, { memo, useState } from "react";

// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  Box,
  FormControl,
  IconButton,
  Popper,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import { Cancel, Check } from "@mui/icons-material";
import { v4 } from "uuid";
import clienteAxios from "../../../../../../config/axios";
import AlertaContext from "../../../../../../Context/Alerta/AlertaContext";
import { useContext } from "react";

const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  margin: {
    margin: "0px",
    padding: "2px",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));
const RowAgregarArma = (props) => {
  const { setagregar, setitem, item } = props;
  const { mostrarAlerta } = useContext(AlertaContext);
  const [medicinasData, setmedicinasData] = useState([]);
  const [itemRow, setItemRow] = useState({
    order: "",
    medicina: "",
    dosis: "",
    cantidad: "1",
    via: "",
    serie: "",
    frecuencia: "1",
    inicio: "0",
  });
  const PopperMy = function(props) {
    return (
      <Popper {...props} style={useRowStyles.popper} placement="bottom-start" />
    );
  };
  const handleChange = (e) => {
    setItemRow({ ...itemRow, [e.target.name]: e.target.value });
  };
  const botonDisabled = () => {
    if (itemRow.medicina === "" || itemRow.cantidad === "") {
      return true;
    } else {
      return false;
    }
  };

  const classes = useRowStyles();
  //gql eliminar user

  const handleAgregar = async () => {
    try {
      const order = v4();
      const hospMedicamentos = {
        medicamentosCabecera: [
          {
            ...itemRow,
            order,
          },
          ...item.hospMedicamentos.medicamentosCabecera,
        ],
        medicamentosHorario: [
          {
            fecha: new Date(
              Date.now() - new Date().getTimezoneOffset() * 60 * 1000
            )
              .toISOString()
              .substr(0, 10),
            nameMedicinaHorarios: itemRow.medicina,
            h0: "",
            h1: "",
            h2: "",
            h3: "",
            h4: "",
            h5: "",
            h6: "",
            h7: "",
            h8: "",
            h9: "",
            h10: "",
            h11: "",
            h12: "",
            h13: "",
            h14: "",
            h15: "",
            h16: "",
            h17: "",
            h18: "",
            h19: "",
            h20: "",
            h21: "",
            h22: "",
            h23: "",
            order,
          },
          ...item.hospMedicamentos.medicamentosHorario,
        ],
      };

      setitem({
        ...item,
        hospMedicamentos,
      });
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
          >
            <IconButton
              className={classes.margin}
              onClick={() => {
                setagregar(false);
                setItemRow({
                  order: "",
                  medicina: "",
                  dosis: "",
                  cantidad: "1",
                  via: "",
                  serie: "",
                  frecuencia: "1",
                  inicio: "0",
                });
              }}
            >
              <Cancel fontSize="small" color="secondary" />
            </IconButton>
            <IconButton
              className={classes.margin}
              disabled={botonDisabled()}
              color={botonDisabled() ? "secondary" : "inherit"}
              onClick={() => {
                handleAgregar();

                setagregar(false);
                setItemRow({
                  order: "",
                  medicina: "",
                  dosis: "",
                  cantidad: "1",
                  via: "",
                  serie: "",
                  frecuencia: "1",
                  inicio: "0",
                });
              }}
            >
              <Check fontSize="small" />
            </IconButton>{" "}
          </Box>
        </TableCell>
        {/* las demas columnas */}

        <>
          <TableCell
            checkbox
            size="small"
            align="center"
            className={classes.celda}
          >
            <FormControl fullWidth>
              <Autocomplete
                filterOptions={(x) => x}
                PopperComponent={PopperMy}
                options={medicinasData.map((item) => {
                  return item.invNombre + "/+/" + item.invId;
                })}
                getOptionLabel={(option) => {
                  return option.split("/+/")[0];
                }}
                id="controlled-demo"
                value={itemRow.medicina}
                paperprops
                onChange={async (event, newValue) => {
                  if (newValue) {
                    const options = newValue.split("/+/");
                    const itemF = medicinasData.find((itemPersona) => {
                      return itemPersona.invId === Number(options[1]);
                    });

                    setItemRow({
                      ...itemRow,
                      serie: itemF.invSerie,
                      medicina: itemF.invNombre,
                      llevaIva: itemF.invIva,
                      incluyeIva: itemF.invIncluyeIva,
                      precio: itemF.invprecios[0],
                    });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    // error={error.recMascNombre}

                    fullWidth
                    onChange={async (e) => {
                      if (e.target.value === "") {
                        return;
                      }
                      try {
                        setItemRow({
                          ...itemRow,
                          medicina: e.target.value,
                        });
                        const res = await clienteAxios.get(
                          `/inventario/filtro/0?search=${e.target.value}&tipo=`
                        );

                        setmedicinasData(res.data.data);
                      } catch (error) {
                        mostrarAlerta("Hubo un error", "error");
                      }
                    }}
                    // InputProps={{
                    //   ...params.InputProps,
                    //   endAdornment: (
                    //     <React.Fragment>
                    //       {!editar ? (
                    //         <IconButton
                    //           size="small"
                    //           aria-label=""
                    //           onClick={async () => {
                    //             seteditarProveedor(false);
                    //             setopenProveedor(true);
                    //           }}
                    //         >
                    //           <AddCircleOutlineTwoTone color="primary" />
                    //         </IconButton>
                    //       ) : null}
                    //       {params.InputProps.endAdornment}
                    //     </React.Fragment>
                    //   ),
                    // }}
                  />
                )}
              />
            </FormControl>
          </TableCell>
          <TableCell
            padding="normal"
            size="small"
            align="center"
            className={classes.celda}
          >
            <TextField
              name="dosis"
              value={itemRow.dosis}
              onChange={(e) => handleChange(e)}
              size="small"
              fullWidth
            />
          </TableCell>
          <TableCell
            padding="checkbox"
            size="small"
            align="center"
            className={classes.celda}
          >
            <TextField
              type={"number"}
              name="cantidad"
              value={itemRow.cantidad}
              onChange={(e) => handleChange(e)}
              size="small"
              fullWidth
            />
          </TableCell>
          <TableCell
            checkbox
            size="small"
            align="center"
            className={classes.celda}
          >
            <TextField
              name="via"
              value={itemRow.via}
              onChange={(e) => handleChange(e)}
              size="small"
              fullWidth
            />
          </TableCell>{" "}
          <TableCell
            padding="checkbox"
            size="small"
            align="center"
            className={classes.celda}
          >
            <TextField
              type={"number"}
              name="inicio"
              value={itemRow.inicio}
              onChange={(e) => {
                setItemRow({
                  ...itemRow,
                  inicio:
                    e.target.valueAsNumber > 23
                      ? 23
                      : e.target.valueAsNumber < 0
                      ? 0
                      : e.target.valueAsNumber,
                });
              }}
              size="small"
              fullWidth
            />
          </TableCell>
          <TableCell
            padding="checkbox"
            size="small"
            align="center"
            className={classes.celda}
          >
            <TextField
              type={"number"}
              name="frecuencia"
              value={itemRow.frecuencia}
              onChange={(e) => {
                setItemRow({
                  ...itemRow,
                  frecuencia:
                    e.target.valueAsNumber < 1
                      ? 1
                      : e.target.valueAsNumber > 23
                      ? 23
                      : e.target.valueAsNumber,
                });
              }}
              size="small"
              fullWidth
            />
          </TableCell>
        </>
      </TableRow>
    </React.Fragment>
  );
};

export default memo(RowAgregarArma);
